module.exports = "/_next/static/media/default-avatar-1.a8dce92f.jpg";